import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { House, FolderSimple, Gear, SignOut, List, X, Robot, FilmStrip, Megaphone } from "@phosphor-icons/react";

const NAV_ITEMS = [
  { label: "Dashboard", path: "/", icon: House },
  { label: "Projects", path: "/projects", icon: FolderSimple },
  { label: "Videos", path: "/videos", icon: FilmStrip },
  { label: "Scraper", path: "/scraper", icon: Robot },
  { label: "Ads", path: "/ads", icon: Megaphone },
  { label: "Settings", path: "/settings", icon: Gear },
];

export default function Sidebar() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <>
      {/* Mobile toggle */}
      <button
        data-testid="sidebar-mobile-toggle"
        className="fixed top-4 left-4 z-50 md:hidden bg-[#141417] border border-[#2A2A2E] p-2 rounded-sm text-white"
        onClick={() => setCollapsed(!collapsed)}
      >
        {collapsed ? <X size={20} /> : <List size={20} />}
      </button>

      <aside
        data-testid="sidebar"
        className={`
          fixed md:relative z-40 h-screen bg-[#141417] border-r border-[#2A2A2E]
          transition-transform duration-200
          ${collapsed ? "translate-x-0" : "-translate-x-full md:translate-x-0"}
          w-60 flex flex-col
        `}
      >
        {/* Logo */}
        <div className="p-5 border-b border-[#2A2A2E]">
          <h1 className="font-black text-xl tracking-tighter text-white" style={{ fontFamily: 'Chivo, sans-serif' }}>
            CMS<span className="text-[#E53935]">Portal</span>
          </h1>
          <p className="text-[10px] text-[#A1A1AA] tracking-[0.2em] uppercase mt-1">Content Management</p>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-4 px-3 space-y-1">
          {NAV_ITEMS.map((item) => {
            const isActive = item.path === "/" ? location.pathname === "/" : location.pathname.startsWith(item.path);
            const Icon = item.icon;
            return (
              <button
                key={item.path}
                data-testid={`nav-${item.label.toLowerCase()}`}
                onClick={() => { navigate(item.path); setCollapsed(false); }}
                className={`
                  w-full flex items-center gap-3 px-3 py-2.5 text-sm rounded-sm transition-colors duration-200
                  ${isActive
                    ? "bg-[#E53935]/10 text-[#E53935] border border-[#E53935]/20"
                    : "text-[#A1A1AA] hover:text-white hover:bg-[#1E1E22] border border-transparent"
                  }
                `}
              >
                <Icon size={18} weight={isActive ? "fill" : "regular"} />
                {item.label}
              </button>
            );
          })}
        </nav>

        {/* User & Logout */}
        <div className="p-4 border-t border-[#2A2A2E]">
          <div className="text-xs text-[#A1A1AA] mb-2 truncate">{user?.email}</div>
          <button
            data-testid="logout-btn"
            onClick={logout}
            className="w-full flex items-center gap-2 px-3 py-2 text-sm text-[#A1A1AA] hover:text-[#E53935] hover:bg-[#E53935]/5 rounded-sm transition-colors duration-200 border border-transparent hover:border-[#E53935]/20"
          >
            <SignOut size={16} />
            Logout
          </button>
        </div>
      </aside>
    </>
  );
}
